import { generatePath, Link } from 'react-router';
import { Launch, Toc } from '@mui/icons-material';

import { Content } from '@/services/contents/content.vm';
import { Route } from '@/services/routes/route.vm';
import { Stage } from '@/services/stages/stage.vm';
import theme from '@/constants/theme';
import Table from '@/components/dataDisplay/Table';
import { routes } from '@/constants/routes';
import Button from '@/components/input/Button';

import CreateContentButton from '../../contents/CreateContentButton';

interface Props {
  routeId: Route['id'];
  stageId: Stage['id'];
  contents: Content[];
  setIsOrdering: React.Dispatch<React.SetStateAction<boolean>>;
}

const StageContentsTable: React.FC<Props> = ({ routeId, stageId, contents, setIsOrdering }) => {
  const mapContents = (contents: Content[]) => {
    if (!contents) return [];
    return contents?.map((route) => ({
      id: route.id,
      title: route.title,
      type: route.type,
      points: route.points,
      order: route.order,
      routeId: route.routeId,
    }));
  };

  const screenHeader = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <h2 style={{ color: theme.colors.text.subtitle }}>Contenidos de la etapa</h2>
      <div style={{ display: 'flex', gap: 16 }}>
        {contents?.length > 1 && (
          <Button variant="outline" Icon={Toc} onClick={() => setIsOrdering(true)}>
            Reordenar
          </Button>
        )}
        <CreateContentButton routeId={routeId} stageId={stageId} isStageContent />
      </div>
    </div>
  );

  if (!routeId) return null;
  if (!contents || contents.length === 0)
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {screenHeader}
        <p style={{ color: theme.colors.text.caption }}>Esta etapa aún no tiene contenidos.</p>
      </div>
    );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {screenHeader}
      <Table
        columns={[
          {
            title: 'Título',
            field: 'title',
            render: (row: any) => (
              <Link
                to={generatePath(routes.admin.routes.stages.contents.detail, {
                  contentId: row.id,
                  routeId,
                  stageId,
                })}
                style={{
                  minWidth: 120,
                  display: 'flex',
                  gap: 8,
                  textDecoration: 'underline',
                }}
              >
                {row.title}
                <Launch
                  style={{
                    width: 12,
                    height: 12,
                    color: theme.colors.text.caption,
                  }}
                />
              </Link>
            ),
          },
          {
            title: 'Orden',
            field: 'order',
            render: (row: any) => row.order,
          },
          {
            title: 'Puntos',
            field: 'points',
            render: (row: any) => row.points,
          },
          { title: 'Type', field: 'type', render: (row: any) => row.type },
        ]}
        data={mapContents(contents)}
      />
    </div>
  );
};

export default StageContentsTable;
